"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$ = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$outboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$inboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$ = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$outboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$inboundSchema = void 0;
exports.getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityToJSON = getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityToJSON;
exports.getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityFromJSON = getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityFromJSON;
exports.getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestToJSON = getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestToJSON;
exports.getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestFromJSON = getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$;
(function (GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$) {
    /** @deprecated use `GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$inboundSchema` instead. */
    GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$.inboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$outboundSchema` instead. */
    GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$.outboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$outboundSchema;
})(GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$ || (exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$ = GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$ = {}));
function getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityToJSON(getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity) {
    return JSON.stringify(exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$outboundSchema
        .parse(getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity));
}
function getPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyTransactionsInAreaAreasPropertyTransactionsGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$inboundSchema = z.object({
    "fields[transaction]": z.array(shared.MultiplePropertyTransactionUserFields$inboundSchema),
    "filter[end_month]": z.string().optional(),
    "filter[max_bedrooms]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[min_bedrooms]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[start_month]": z.string().optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sort: z.string().optional(),
    street_group_property_id: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "fields[transaction]": "fieldsTransaction",
        "filter[end_month]": "filterEndMonth",
        "filter[max_bedrooms]": "filterMaxBedrooms",
        "filter[max_price]": "filterMaxPrice",
        "filter[min_bedrooms]": "filterMinBedrooms",
        "filter[min_price]": "filterMinPrice",
        "filter[property_type]": "filterPropertyType",
        "filter[start_month]": "filterStartMonth",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$outboundSchema = z.object({
    fieldsTransaction: z.array(shared.MultiplePropertyTransactionUserFields$outboundSchema),
    filterEndMonth: z.string().optional(),
    filterMaxBedrooms: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMinBedrooms: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterStartMonth: z.string().optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sort: z.string().optional(),
    streetGroupPropertyId: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        fieldsTransaction: "fields[transaction]",
        filterEndMonth: "filter[end_month]",
        filterMaxBedrooms: "filter[max_bedrooms]",
        filterMaxPrice: "filter[max_price]",
        filterMinBedrooms: "filter[min_bedrooms]",
        filterMinPrice: "filter[min_price]",
        filterPropertyType: "filter[property_type]",
        filterStartMonth: "filter[start_month]",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$;
(function (GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$) {
    /** @deprecated use `GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$inboundSchema` instead. */
    GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$.inboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$inboundSchema;
    /** @deprecated use `GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$outboundSchema` instead. */
    GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$.outboundSchema = exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$outboundSchema;
})(GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$ || (exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$ = GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$ = {}));
function getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestToJSON(getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest) {
    return JSON.stringify(exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$outboundSchema
        .parse(getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest));
}
function getPropertyTransactionsInAreaAreasPropertyTransactionsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyTransactionsInAreaAreasPropertyTransactionsGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertytransactionsinareaareaspropertytransactionsget.js.map